import { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { driverDashboardService } from "services/driverDashboardService";
import { Greeting, TilesGrid, Tile, TileLabel, TileValue } from "./styles";

const TODAY = dayjs().format("YYYY-MM-DD");

interface ITiles {
  punctuality: number | null;
  complaints: number | null;
  deliveries: number | null;
  boxesBalance: number | null;
}

export function DriverHome() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [driverName, setDriverName] = useState<string | null>(null);
  const [tiles, setTiles] = useState<ITiles>({
    punctuality: null,
    complaints: null,
    deliveries: null,
    boxesBalance: null,
  });

  useEffect(() => {
    driverDashboardService.getMyDriver().then((driver) => setDriverName(driver.name));
  }, []);

  useEffect(() => {
    const params = { startDate: TODAY, endDate: TODAY };

    Promise.allSettled([
      driverDashboardService.getMyPunctuality(params),
      driverDashboardService.getMyComplaints(params),
      driverDashboardService.getMyDeliveries(params),
      driverDashboardService.getMyBoxes(params),
    ]).then(([punctuality, complaints, deliveries, boxes]) => {
      setTiles({
        punctuality: punctuality.status === "fulfilled" ? punctuality.value.punctuality : null,
        complaints: complaints.status === "fulfilled" ? complaints.value.totalComplaints : null,
        deliveries:
          deliveries.status === "fulfilled"
            ? deliveries.value.results.reduce((sum, day) => sum + day.deliveries.length, 0)
            : null,
        boxesBalance:
          boxes.status === "fulfilled"
            ? boxes.value.results.reduce((sum, day) => sum + (day.boxesSent - day.boxesReturned), 0)
            : null,
      });
      setLoading(false);
    });
  }, []);

  const formatValue = (value: number | null, suffix = "") =>
    value === null ? "-" : `${value}${suffix}`;

  const tileValue = (value: number | null, suffix = "") =>
    loading ? <Skeleton variant="text" width="3ch" sx={{ fontSize: "1.6rem" }} /> : formatValue(value, suffix);

  return (
    <div aria-busy={loading}>
      <Greeting>
        Olá, {driverName === null ? <Skeleton variant="text" width="8ch" sx={{ display: "inline-block" }} /> : driverName}
      </Greeting>

      <TilesGrid>
        <Tile onClick={() => navigate("/motorista/pontualidade")} disabled={loading}>
          <TileLabel>Pontualidade hoje</TileLabel>
          <TileValue>{tileValue(tiles.punctuality, "%")}</TileValue>
        </Tile>

        <Tile onClick={() => navigate("/motorista/quebras")} disabled={loading}>
          <TileLabel>Quebras hoje</TileLabel>
          <TileValue>{tileValue(tiles.complaints)}</TileValue>
        </Tile>

        <Tile onClick={() => navigate("/motorista/entregas")} disabled={loading}>
          <TileLabel>Entregas hoje</TileLabel>
          <TileValue>{tileValue(tiles.deliveries)}</TileValue>
        </Tile>

        <Tile onClick={() => navigate("/motorista/caixas")} disabled={loading}>
          <TileLabel>Saldo de caixas hoje</TileLabel>
          <TileValue>{tileValue(tiles.boxesBalance)}</TileValue>
        </Tile>
      </TilesGrid>
    </div>
  );
}

export default DriverHome;